import Modal from '@/components/Modal'
import { Box, Typography, Button } from '@mui/material'
import InfoIcon from '@mui/icons-material/InfoOutlined'

type Props = {
  open: boolean
  onClose: () => void
}

const BatchSnapshotInfo = ({ open, onClose }: Props) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box p={4}>
        <Typography display="flex" alignItems="center" mb={2} variant="h5">
          <InfoIcon sx={{ mr: 1 }} />
          Batch Snapshot
        </Typography>
        <Typography fontSize={14} mb={2}>
          Batch Snapshots are the best way to get a quick view of what's in a
          batch without even having to download it... but it also helps us out!
        </Typography>
        <Typography fontSize={14}>
          What you might not know is that when you download a batch, it prevents
          a couple things from happening on our end:
        </Typography>
        <ol style={{ fontSize: 14 }}>
          <li>Customers are no longer able to edit their shipping address</li>
          <li>
            Our Support team cannot refund an order without contacting you
            directly
          </li>
        </ol>
        <Typography fontSize={14} mb={2}>
          We want to be able to assist our customers with address changes and
          refunds all the way up until their order is in your fulfillment
          system. This makes it very important that our vendors only download
          batches when they are 100% ready to ship. Batch Snapshots will allow
          you to see an overview of the batch before you are ready to ship, so
          you can see how many of each SKU are needed without downloading the
          batch and preventing last minute address changes or refunds.
        </Typography>
        <Typography fontSize={14} mb={2}>
          You can also select multiple batches and see the number of open orders
          for all of them combined by clicking the camera icon next to the
          download selected button that appears when you select more than one
          batch.
        </Typography>
        <Box display="flex" justifyContent="end">
          <Button variant="contained" onClick={onClose}>
            Ok
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default BatchSnapshotInfo
